module.exports = __webpack_public_path__ + "img/west-summer-1920x550.6853f990.jpg";